<template>
    <Modal :close_button="true" :size="'modal-lg'" mid="member-sessions">
        <template v-slot:header>
            {{$t('management_console.members.sessions_for', { username: member && member.username ? member.username : '' })}}
        </template>
        <template v-slot:body>
            <div v-if="sessions.length > 0" class="table-responsive rounded border">
                <table class="table table-light table-hover small text-gray-700 mb-0">
                    <thead>
                        <tr class="align-middle">
                            <th scope="col" class="text-gray-600 text-center">IP</th>
                            <th scope="col" class="text-gray-600 text-center">{{$t('management_console.members.browser')}}</th>
                            <th scope="col" class="text-gray-600 text-center">{{$t('management_console.common.created_at')}}</th>
                            <th scope="col" class="text-gray-600 text-center">{{$t('management_console.common.actions')}}</th>
                        </tr>
                    </thead>
                    <tbody class="border-top-0">
                        <tr v-for="session in sessions" :key="session.id" class="align-middle">
                            <td><p class="m-0 text-center text-nowrap">{{session.ip}}</p></td>
                            <td><p class="m-0 text-center">{{$filters.ParseUserAgent(session.ua)}}</p></td>
                            <td><p class="m-0 text-center text-nowrap">{{$filters.PrettyDate(session.created_at)}}</p></td>
                            <td class="text-center">
                                <button
                                v-if="can_remove_sessions"
                                type="button"
                                class="btn btn-sm btn-outline-danger"
                                :disabled="deleting_session_id !== null"
                                @click="delete_session(session)">
                                    <span v-if="deleting_session_id === session.id" class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                                    {{$t('controls.remove')}}
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p v-else class="mb-0 text-gray-600">
                {{$t('management_console.members.no_sessions')}}
            </p>
        </template>
    </Modal>
</template>

<script>
import InventoryMemberStore from '@/common/store/inventory_member.js'

export default {
    props: {
        member: {
            type: Object,
            default: () => ({})
        }
    },
    data: function () {
        return {
            deleting_session_id: null
        }
    },
    computed: {
        user: function () {
            return this.$store.state.user
        },
        sessions: function () {
            return this.member && Array.isArray(this.member.sessions) ? this.member.sessions : []
        },
        can_remove_sessions: function () {
            return this.user.role === 'admin' || this.user.permissions.api.includes('DELETE_/v1/members/sessions/:member_id/:session_id')
        }
    },
    methods: {
        delete_session: async function (session) {
            if (this.deleting_session_id !== null || !this.member || typeof this.member.id !== 'string') {
                return
            }

            this.deleting_session_id = session.id
            try {
                const response = await InventoryMemberStore.dispatch('DELETE_SESSION', {
                    session_id: session.id,
                    member_id: this.member.id
                })

                if (response.status === 0) {
                    this.$bus.$emit('Notification/show', {
                        title: this.$t('notifications.operation_success'),
                        msg: this.$t('management_console.members.session_deleted'),
                        level: 'success'
                    })
                } else {
                    this.$bus.$emit('Notification/show', {
                        title: this.$t('notifications.something_went_wrong'),
                        msg: this.$t('notifications.please_retry_the_operation_or_refresh'),
                        level: 'danger'
                    })
                }
            } finally {
                this.deleting_session_id = null
            }
        }
    }
}
</script>
